import { ga, adjust, amplitude } from 'js/analytics/adapters'
import {
  baseWebEventProps,
  webpageProps,
  userConsentValue,
} from 'js/analytics/standardizedProps'

export const trackStartRegistration = ({
  entryPoint = '',
  linkText = '',
  linkType = '',
}: { entryPoint?: string; linkText?: string; linkType?: string } = {}) => {
  ga.track('start_registration')
  adjust.track('Start Registration')
  const consent = userConsentValue()
  amplitude.track('user_start_registration', {
    ...baseWebEventProps(),
    ...webpageProps(),
    action_name: 'start',
    action_type: 'active',
    // Single event, differentiated by interaction_type.
    interaction_type: 'cta',
    ...(consent ? { user_consent: consent } : {}),
    ...(entryPoint ? { event_source: entryPoint } : {}),
    ...(linkText ? { link_text: linkText } : {}),
    ...(linkType ? { link_type: linkType } : {}),
  })
}
